import { render, staticRenderFns } from "./GroupAbout.vue?vue&type=template&id=f1074012&"
import script from "./GroupAbout.vue?vue&type=script&lang=js&"
export * from "./GroupAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports